// extracted by mini-css-extract-plugin
export default {"section":"Vt-z","inSectionButton":"Wt-z","addressCard":"Xt-z","disabled":"Yt-z","cautionBox":"Zt-z","failureBox":"_t-z","fade-out":"au-z","successBox":"bu-z"};